import React from "react";
import {IconButton, MenuItem, TextField} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface SelectFilterProps {
    label: string;
    value: number;
    setFilter: (value: string) => void;
    removeFilter: () => void;
    options: { label: string; value: string }[];
    isMobile: boolean;
}

const SelectFilter: React.FC<SelectFilterProps> = ({label, value, setFilter, removeFilter, options, isMobile}) => (
    <TextField
        label={label}
        select
        variant="standard"
        margin="normal"
        value={value}
        onChange={(e) => setFilter(e.target.value)}
        fullWidth={isMobile}
        sx={{minWidth: 180}}
        InputProps={{
            endAdornment: value ? (
                <IconButton
                    onClick={removeFilter}
                    size="small"
                    sx={{marginRight: 2}}
                >
                    <ClearIcon/>
                </IconButton>
            ) : null,
        }}
    >
        {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        ))}
    </TextField>
);

export default SelectFilter;